/**
 * O dia de hoje como sai numa etiqueta: `14/09/2026` (F140).
 *
 * É o campo "Data da impressão" do selo de garantia. Formatado aqui, no
 * navegador de quem imprime: o renderizador de etiqueta não lê relógio, para
 * que a mesma entrada dê sempre o mesmo papel.
 */
export const printedOnToday = (now: Date = new Date()): string =>
  now.toLocaleDateString('pt-BR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  })
